module.exports = __webpack_public_path__ + "static/media/insurance-fund.b9b8b719.jpg";